import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import globalThis, { isCloudflareWorkers, isNodeJs } from './global.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import invalidKeyInput from './invalid_key_input.js';
import { encodeBase64 } from './base64url.js';
import formatPEM from '../lib/format_pem.js';
import { JOSENotSupported } from '../util/errors.js';

var genericExport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keyType, keyFormat, key) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isCryptoKey(key)) {
              _context.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput(key, 'CryptoKey'));

          case 2:
            if (key.extractable) {
              _context.next = 4;
              break;
            }

            throw new TypeError('CryptoKey is not extractable');

          case 4:
            if (!(key.type !== keyType)) {
              _context.next = 6;
              break;
            }

            throw new TypeError("key is not a ".concat(keyType, " key"));

          case 6:
            _context.t0 = formatPEM;
            _context.t1 = encodeBase64;
            _context.t2 = Uint8Array;
            _context.next = 11;
            return crypto.subtle.exportKey(keyFormat, key);

          case 11:
            _context.t3 = _context.sent;
            _context.t4 = new _context.t2(_context.t3);
            _context.t5 = (0, _context.t1)(_context.t4);
            _context.t6 = "".concat(keyType.toUpperCase(), " KEY");
            return _context.abrupt("return", (0, _context.t0)(_context.t5, _context.t6));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function genericExport(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export var toSPKI = function toSPKI(key) {
  return genericExport('public', 'spki', key);
};
export var toPKCS8 = function toPKCS8(key) {
  return genericExport('private', 'pkcs8', key);
};

var getNamedCurve = function getNamedCurve(keyData) {
  var keyDataStr = keyData.toString();

  switch (true) {
    case keyDataStr.includes(new Uint8Array([0x06, 0x07, 0x2a, 0x86, 0x48, 0xce, 0x3d, 0x02, 0x01, 0x06, 0x08, 0x2a, 0x86, 0x48, 0xce, 0x3d, 0x03, 0x01, 0x07]).toString()):
      return 'P-256';

    case keyDataStr.includes(new Uint8Array([0x06, 0x07, 0x2a, 0x86, 0x48, 0xce, 0x3d, 0x02, 0x01, 0x06, 0x05, 0x2b, 0x81, 0x04, 0x00, 0x22]).toString()):
      return 'P-384';

    case keyDataStr.includes(new Uint8Array([0x06, 0x07, 0x2a, 0x86, 0x48, 0xce, 0x3d, 0x02, 0x01, 0x06, 0x05, 0x2b, 0x81, 0x04, 0x00, 0x23]).toString()):
      return 'P-521';

    case (isCloudflareWorkers() || isNodeJs()) && keyDataStr.includes(new Uint8Array([0x06, 0x03, 0x2b, 0x65, 0x70]).toString()):
      return 'Ed25519';

    case isNodeJs() && keyDataStr.includes(new Uint8Array([0x06, 0x03, 0x2b, 0x65, 0x71]).toString()):
      return 'Ed448';

    default:
      throw new JOSENotSupported('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
  }
};

var genericImport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(replace, keyFormat, pem, alg, options) {
    var _a, algorithm, keyUsages, keyData, isPublic, namedCurve;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            keyData = new Uint8Array(globalThis.atob(pem.replace(replace, '')).split('').map(function (c) {
              return c.charCodeAt(0);
            }));
            isPublic = keyFormat === 'spki';
            _context2.t0 = alg;
            _context2.next = _context2.t0 === 'PS256' ? 5 : _context2.t0 === 'PS384' ? 5 : _context2.t0 === 'PS512' ? 5 : _context2.t0 === 'RS256' ? 8 : _context2.t0 === 'RS384' ? 8 : _context2.t0 === 'RS512' ? 8 : _context2.t0 === 'RSA-OAEP' ? 11 : _context2.t0 === 'RSA-OAEP-256' ? 11 : _context2.t0 === 'RSA-OAEP-384' ? 11 : _context2.t0 === 'RSA-OAEP-512' ? 11 : _context2.t0 === 'ES256' ? 14 : _context2.t0 === 'ES384' ? 17 : _context2.t0 === 'ES512' ? 20 : _context2.t0 === 'ECDH-ES' ? 23 : _context2.t0 === 'ECDH-ES+A128KW' ? 23 : _context2.t0 === 'ECDH-ES+A192KW' ? 23 : _context2.t0 === 'ECDH-ES+A256KW' ? 23 : _context2.t0 === ((isCloudflareWorkers() || isNodeJs()) && 'EdDSA') ? 26 : 30;
            break;

          case 5:
            algorithm = {
              name: 'RSA-PSS',
              hash: {
                name: "SHA-".concat(alg.substr(-3))
              }
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 31);

          case 8:
            algorithm = {
              name: 'RSASSA-PKCS1-v1_5',
              hash: {
                name: "SHA-".concat(alg.substr(-3))
              }
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 31);

          case 11:
            algorithm = {
              name: 'RSA-OAEP',
              hash: {
                name: "SHA-".concat(parseInt(alg.substr(-3), 10) || 1)
              }
            };
            keyUsages = isPublic ? ['encrypt', 'wrapKey'] : ['decrypt', 'unwrapKey'];
            return _context2.abrupt("break", 31);

          case 14:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-256'
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 31);

          case 17:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-384'
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 31);

          case 20:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-521'
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 31);

          case 23:
            algorithm = {
              name: 'ECDH',
              namedCurve: getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [] : ['deriveBits'];
            return _context2.abrupt("break", 31);

          case 26:
            namedCurve = getNamedCurve(keyData).toUpperCase();
            algorithm = {
              name: "NODE-".concat(namedCurve),
              namedCurve: "NODE-".concat(namedCurve)
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 31);

          case 30:
            throw new JOSENotSupported('Invalid or unsupported "alg" (Algorithm) value');

          case 31:
            return _context2.abrupt("return", crypto.subtle.importKey(keyFormat, keyData, algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages));

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function genericImport(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

export var fromPKCS8 = function fromPKCS8(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
export var fromSPKI = function fromSPKI(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};